import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cursor"
export default class extends Controller {
	moveToEnd() {
		const element = this.element
		const value = element.value

		element.value = ""
		element.value = value
	}
}
